import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import {
	DescriptionSection,
	ImageSection,
	InlineTitle
} from 'app/main/modules/components/FastAddDialogSettingsManager';
import DocumentsDetailsSectionInfo from './details/sections/DocumentsDetailsSectionInfo';

export default {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<DocumentsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="fold_descriptionhtml"
				value={props.model.fold_descriptionhtml}
				sendChange={props.sendChange}
				isEdit={props.isEdit}
			/>
			<InlineTitle text="DETAILS_THUMBNAIL_SECTION" />
			<ImageSection
				fieldName="fold_image"
				fileName={props.model.fold_uid}
				path={`documents/${props.model.fold_uid}`}
				value={props.model.fold_image}
				sendChange={props.sendChange}
			/>
		</>
	),
	showOpenFullDetails: true
} as FastAddDialogSettingsType;
